import React from 'react';
import { FaEnvelope, FaWhatsapp, FaMapMarkerAlt, FaArrowLeft } from 'react-icons/fa';

const SupportView = ({ darkMode, onBack }) => {
    return (
        <div className="support-view">
            <button className="support-back-btn" onClick={onBack}>
                <FaArrowLeft />
            </button>
            <div className="support-container">
                <div className="support-header">
                    <img
                        src={darkMode ? "/edutap-icon-white.png" : "/edutap-icon-black.png"}
                        alt="Edutap Logo"
                        className="support-logo"
                    />
                    <h2>Contact Support</h2>
                    <p>We are here to help you 24/7</p>
                </div>

                <div className="support-details">
                    <div className="support-item">
                        <div className="icon-box">
                            <FaEnvelope />
                        </div>
                        <div className="info-box">
                            <h3>Email Us</h3>
                            <p>hello@paysnug.com</p>
                        </div>
                    </div>

                    <div className="support-item">
                        <div className="icon-box">
                            <FaWhatsapp />
                        </div>
                        <div className="info-box">
                            <h3>WhatsApp</h3>
                            <p><a href={process.env.REACT_APP_AD_LINK} target="_blank" rel="noopener noreferrer">+234 916 000 5957</a></p>
                        </div>
                    </div>

                    <div className="support-item">
                        <div className="icon-box">
                            <FaMapMarkerAlt />
                        </div>
                        <div className="info-box">
                            <h3>Office</h3>
                            <p>Lagos, Nigeria</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SupportView;
